<template>
    <div class="new-home">
        <div class="new-home-head">
            <img class="home-avatar" src="../../../assets/imgs/home/avatar@3x.png" alt="">
            <div class="home-user-info">
                <div class="user-account-con">
                    <span class="user-account van-ellipsis">{{urlData.username}}</span>
                    <img class="user-account-copy" src="../../../assets/imgs/home/copy@3x.png" @click="handlerCopy(urlData.username)">
                </div>
                <div class="user-imei-con">
                    <span class="user-imei">IMEI: {{ urlData.imei }}</span> 
                    <img class="user-imei-copy" src="../../../assets/imgs/home/copy@3x.png" alt="" @click="handlerCopy(urlData.imei)">
                </div>
            </div>
            <img class="info-bg-img" src="../../../assets/imgs/home/person_info_bg.png" alt="">
        </div>
        <div class="new-home-package" v-if="Module_MyFlow">
            <div class="home-package-head" @click="goToMyFlow">
                <div class="flex align-center">
                    <span>{{ $t('home.my_flow') }}</span>
                    <!-- <img class="my-flow-arrow" src="../../../assets/imgs/home/right_arrow@3x.png" alt=""> -->
                    <van-icon class="my-arrow" :name="$i18n.locale ==='ar-AE' ? 'arrow-left' : 'arrow'" />
                </div>
                <div class="flex align-center position-relative" @click.stop="goToMyFlow('order')">
                    <span class="order-num" v-if="orderList.length">{{orderList.length}}</span>
                    <span>{{ $t('order.orderList.title') }}</span>
                    <van-icon class="my-arrow" :name="$i18n.locale ==='ar-AE' ? 'arrow-left' : 'arrow'" />
                    <!-- <img class="my-flow-arrow" src="../../../assets/imgs/home/right_arrow@3x.png" alt=""> -->
                </div>
            </div>
            <div v-if="fData.packageUseDetail" class="home-package-info">
                <h3 class="package-name van-multi-ellipsis--l2">{{ fData.packageUseDetail.goodsName }}</h3>
                <p class="a_activeTime_name" v-if="!fData.packageUseDetail.extendValVos || !fData.packageUseDetail.a_getValue_hideFlowSize || fData.packageUseDetail.a_getValue_hideFlowSize && fData.packageUseDetail.a_getValue_hideFlowSize != '1' ">
                    {{fData.packageUseDetail.a_surplusFlow.type == 'DISC' ? $t('order.remainingHighFlow') : $t("order.remainingFlow")}}: {{fData.packageUseDetail.a_surplusFlow.remainFlow | filterFlow}}
                </p>
                <p v-if="fData.packageUseDetail.status !== 'NOT_ACTIVATED' && fData.packageUseDetail.isUseActive">{{fData.packageUseDetail.a_activeTime.name}}: {{fData.packageUseDetail.a_activeTime.time}}</p>
                <span class="state-tips">{{ fData.packageUseDetail.status !== 'NOT_ACTIVATED' && fData.packageUseDetail.isUseActive ? $t('home.package_useing') : $t('home.unused') }}</span>
            </div>
            <div class="home-no-package" v-else @click="gotoPackages()">
                <span>{{ $t('home.no_data') }}</span> 
                <!-- <span style="text-decoration: underline;" @click="gotoPackages()">, {{$t('home.go_buy')}}</span> -->
            </div>
        </div>
        <van-swipe :autoplay="3000" class="new-home-banner" v-if="Module_Banner && bannerList && bannerList.length" touchable dir="ltr" stop-propagation>
            <van-swipe-item v-for="(banner) in bannerList" :key="banner.id" class="new-home-banner-item" @click="goToBannerDetail(banner)">
                <img width="100%" height="100%" v-lazy="banner.res_uri"/>
                <div :dir="$i18n.locale ==='ar-AE' ? 'rtl' : 'ltr'" v-if="banner.link_to_text" class="link_to_text">{{banner.link_to_text}}</div>
            </van-swipe-item>
            <!-- <van-swipe-item>
                <img width="100%" height="100%" v-lazy="'http://webdevflowmall.ukelink.net:8081/static/img/package_bttc.1b7b244a.jpg'"/>
            </van-swipe-item>
            <van-swipe-item>
                <img width="100%" height="100%" v-lazy="'http://webdevflowmall.ukelink.net:8082/static/img/bg.a80fbf95.jpg'"/>
            </van-swipe-item> -->
                <template #indicator>
                <div></div>
                </template>
        </van-swipe>
        <div class="new-home-nav-bar">
            <div class="new-home-nav-item" @click="goToCoupon()" v-if="Module_Coupons_Page">
                <div class="coupon-icon-con">
                    <img src="../../../assets/imgs/home/coupon@3x.png" alt="">
                    <span v-if="fData.couponCount" >{{ fData.couponCount }}</span>
                </div>
                <div class="name">{{ $t('home.coupons') }}</div>
            </div>
            <div class="new-home-nav-item" @click="goToDownLoadApp()" v-if="Module_DownloadApp">
                <div class="coupon-icon-con">
                    <img src="../../../assets/imgs/home/download_App@3x.png" alt="">
                    <span class="tip-dot">3</span>
                </div>
                <div class="name">{{ $t('home.download_app') }}</div>
            </div>
            <div class="new-home-nav-item" @click="goToCharge()" v-if="Module_ChargeCode">
                <img src="../../../assets/imgs/home/recharge_card@3x.png" alt="">
                <div class="name">{{ $t('home.charge_code') }}</div>
            </div>
            <div class="new-home-nav-item" @click="goToFeedback()" v-if="Module_Feedback">
                <img src="../../../assets/imgs/home/feedback.png" alt="">
                <div class="name">{{ $t('feedback.title') }}</div>
            </div>
            <!-- <div class="new-home-nav-item new-home-nav-item-center" @click="goToFeedback()" v-if="Module_Feedback">
                <img src="../../../assets/imgs/home/my-order.png" alt="">
                <div class="name">{{ $t('订单管理') }}</div>
            </div> -->
        </div>
        <div class="new-home-merits" v-if="Module_Merits">
            <div class="new-home-merits-title">{{$t('home.meritsTitle')}}</div>
            <p class="merits-item">
                <img src="../../../assets/imgs/home/no-card-tip.png" alt=""> {{ $t('home.merits1') }}
            </p> 
            <p class="merits-item">
                <img src="../../../assets/imgs/home/no-change-tip.png" alt=""> {{ $t('home.merits2') }}
            </p>
        </div>
        <div class="new-home-power" v-if="isRegAndLogin">
            {{ $t('common.footer_text') }}
        </div>
        <div class="new-home-footer">
            <van-button class="gobuy-btn" @click="gotoPackages()" block type="info">{{ $t('home.enter_the_mall_list') }}</van-button>
        </div>
    </div>
</template>

<script>
import { keepTwodecimalFixed, isAndroid } from '../../../utils/util';
import cookie from '../../../utils/cookie';
import checkProjectConfig from '@/lib/checkProjectConfig';  
import { Swipe, SwipeItem } from 'vant';
export default {
    name: "NewHome",
    props: {
        fData: {
            type: Object,
            default: () => ({})
        },
    },
    data() {
        let urlData = JSON.parse(sessionStorage.getItem('urlData') || '{}');
        return {
            urlData,
            bannerList: [], // banner列表
            orderList:[],
        }
    },
    components: {
        vanSwipe: Swipe,
        vanSwipeItem: SwipeItem
    },
    computed: {
        Module_MyFlow:function(){
            return checkProjectConfig.setAppThat(this).checkValue("Module_MyFlow",true);
        },
        Module_ChargeCode:function(){
            return checkProjectConfig.setAppThat(this).checkValue("Module_ChargeCode",true);
        },
        Module_Coupons_Page:function(){
            return checkProjectConfig.setAppThat(this).checkValue("Module_Coupons_Page",false);
        },
        Module_DownloadApp:function(){
            return checkProjectConfig.setAppThat(this).checkValue("Module_DownloadApp",false);
        },
        Module_Feedback:function(){
            return checkProjectConfig.setAppThat(this).checkValue("Module_Feedback",false);
        },
        Module_Banner:function(){
            return checkProjectConfig.setAppThat(this).checkValue("Module_Banner",false);
        },
        Module_Merits:function(){
            return checkProjectConfig.setAppThat(this).checkValue("Module_Merits",false);
        },
        isRegAndLogin() {
            let isRegAndLogin = JSON.parse(localStorage.getItem('isRegAndLogin') || 'false');
            return isRegAndLogin;
        },
    },
    filters: {
        filterFlow(da) {
        if (da == 0) return "0MB";
        if (!da) return "";
        let flow = keepTwodecimalFixed(da < 1000 ? da : da / 1024);
        let langType = cookie.getCookie('langType')
        // 部分欧洲国家小数点采取 ， 形式
        let country = ['es-ES','pt-PT','de-DE','fr-FR']; 
        let showFlow = flow.toString().replace(/\.00$|0$/, "")
        if(country.includes(langType)){
            showFlow = showFlow.replace('.',',')
        }
        return `${showFlow}${(da < 1000 && "MB") || "GB"}`;
        }
    },
    mounted() {
        this.getHomeBanner();
        this.getCoverList();
        this.getOrderList();
    },
    methods: {
        // 查询国家
        getCoverList() {
            let urlData = JSON.parse(sessionStorage.getItem('urlData') || '{}');
            let countryCode = urlData.registerCountry || urlData.placeCode;
            return this.getCoverListMixin().then(res => {
                let countryName = (res.data || []).find(item => item.iso2 === countryCode)?.countryName;
                sessionStorage.setItem('registerCountryName', countryName || '');
            }).catch(err => {
                this.$toast(err)
            });
        },
        // 设置使用中标识位置
        setUseStyle() {
            let limit = document.querySelector('.state-tips')?.offsetWidth;
            let width = document.querySelector('.a_activeTime_name')?.offsetWidth;
            let allWidth = document.querySelector('.package-name')?.offsetWidth;
            if(limit && width && (width + limit >= allWidth - 50)){
                document.querySelector('.state-tips')?.classList.add('state-tips-long');
            }
        },
        // 复制账号
        handlerCopy(value) {
            const clipboard = navigator.clipboard || {
                writeText: (text) => {
                    return new Promise((resolve, reject) => {
                        try {
                            const input = document.createElement('input')
                            input.value = text
                            document.body.appendChild(input)
                            input.select()
                            document.execCommand('copy')
                            document.body.removeChild(input)
                            resolve()
                        } catch (err) {
                            reject(err)
                        }
                    })
                }
            }
            if (clipboard) {
                clipboard.writeText(value)
                .then(() => {
                    console.log('success');
                    this.$toast(this.$t('home.copy_success') );
                })
                .catch(() => {
                    console.log('failed');
                    this.$toast(this.$t('home.copy_fail') );
                });
            }
        },
        // 跳转到我的流量页面
        goToMyFlow(type) {
            sessionStorage.removeItem('orderType');
            if(type){
                sessionStorage.setItem('orderType',type);
            }
            this.$router.push(this.$setRouteQuery({name: 'OrderList',},this));
        },
        // 查询订单
        getOrderList(){
            this.$http
            .post({
            url: "/bss/app/order/queryOrderListForApp",
            data: {
                perPageCount: 1000,
                orderStatusList: ['UNPAID'],
                queryLimitFlag: true,
                custTerminalFlag: 1,
                filterTopupCode: 1,
            }
            })
            .then(res => {
                if(res.data && res.data?.dataList?.length){
                    this.orderList = res.data.dataList;
                }
            })
            .catch(err => {
                this.$toast(err);
                console.log(err);
            });
        },
        // 进入套餐列表页面
        gotoPackages() {
            this.$router.push(this.$setRouteQuery({name: 'Packages'},this));
        },
        goToCharge() {
            this.$router.push(this.$setRouteQuery({name: 'DiscountCodepager'},this));
        },
        goToCoupon()  {
            this.$router.push(this.$setRouteQuery({name: 'Coupons'},this));
        },
        // 去下载APP
        goToDownLoadApp() {
            this.$router.push(this.$setRouteQuery({name: 'IntroAPP'},this));
            // 打开新的标签页
            // window.open('https://mph5.ucloudlink.com/?uuid=4fb9b86a-3604-4cd8-80ac-9d3f0d419fa2&lang=zh-CN', '_blank');
        },
        // 跳转意见反馈页面
        goToFeedback() {
            this.$router.push(this.$setRouteQuery({name: 'Feedback'},this));
        },
        // 获取banner
        getHomeBanner() {
            let placeCode = JSON.parse( sessionStorage.getItem('urlData') || '{}').placeCode  ||
								    JSON.parse( sessionStorage.getItem('ProjectConfigDetailData') || '{}').placeCode;
            if(!this.Module_Banner) return;
            this.$http.post({
                url: '/webmps/marketing/banner/queryAll',
                data: {
                    lang: cookie.get('langType') || conf.appDefaultLangType,
                    mvno_code: this.urlData.mvnoCode,
                    channel_code: "iot_glocalme_app",
                    position_code:"banner_flow_mall_bottom",
                    org_code: this.urlData.orgCode,
                    region_code: this.urlData.registerCountry || placeCode,
                }
            })
            .then((res) => {
                if(res.data && res.data.length){
                    this.bannerList = res.data.map(item => {
                        const fixedStr = item.link_to.replace(/(\w+):/g, '"$1":')
                                                            // 2. 统一引号格式
                                                            .replace(/'/g, '"');
                        let content = {};
                        try {
                            content = JSON.parse(fixedStr || '{}');
                        } catch (error) {
                            content.url = item.link_to;
                        }
                        return {
                            ...item,
                            link_to_url: content?.url,
                            link_to_text: content?.text,
                        }
                    })

                    
                    this.$nextTick(() => {
                        // 设置固定1:4 
                        let bannerItems = document.querySelector('.new-home-banner');
                        if(bannerItems.offsetWidth){
                             bannerItems.style.height = (bannerItems.offsetWidth / 4) + 'px'; // 设置高度为宽度的1/4
                        }
                    })
                }
            })
            .catch((err) => {
                console.log(err);
            });
        },
        // 跳转banner详情
        goToBannerDetail(banner){
            if(!banner.link_to_url) return;
            if(banner.link_to_url.startsWith('http')){
                window.open(banner.link_to_url, '_blank');
                return;
            }
            this.$router.push(this.$setRouteQuery({path: banner.link_to_url},this))
        },
    }
}
</script>

<style lang="less" scoped>
.new-home {
    padding: 10px 12px 58px;
    .flex {
        display: flex;
    }
    .align-center {
        align-items: center;
    }
    .position-relative {
        position: relative;
    }
    .new-home-head {
        position: relative;
        background-color: #4361EE;
        border-radius: 12px;
        height: 96px;
        padding: 12px;
        display: flex;
        justify-content: flex-between;
        align-items: center;
        color: #fff;
        .home-avatar {
            width: 50px;
            height: 50px;
            margin-right: 12px;
        }
        .home-user-info {
            height: 48px;
            display: flex;
            justify-content: space-between;
            flex-direction: column;
            .user-account-con {
                width: calc(100vw - 110px);
                display: flex;
                align-items: center;
                font-family: PingFang SC;
                font-size: 15px;
                font-variation-settings: "opsz" auto;
                .user-account-copy {
                    width: 16px;
                    height: 16px;
                    margin-left: 8px;
                }
            }
            .user-imei-con {
                display: flex;
                align-items: center;
                font-family: PingFang SC;
                font-size: 12px;
                opacity: 0.7;
                font-variation-settings: "opsz" auto;
                .user-imei-copy {
                    width: 16px;
                    height: 16px;
                    margin-left: 8px;
                }
            }
        }
        .info-bg-img {
            position: absolute;
            right: 0;
            top: 0;
            width: 75%;
            height: 100%;
            opacity: 0.5;
            pointer-events: none;
        }
    }
    .new-home-package {
        background-color: #fff;
        // min-height: 162px;
        border-radius: 12px;
        margin-top: 12px;
        padding: 0 12px;
        .home-package-head {
            border-bottom: 1px solid #F0F0F0;
            height: 56px;
            line-height: 56px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            font-family: PingFang SC;
            font-size: 14px;
            font-weight: 600;
            .my-flow-arrow {
                width: 20px;
                height: 20px;
            }
            .my-arrow {
                top: 1px;
            }
            .order-num {
                position: absolute;
                background-color: #FF4E4E;
                color: #fff;
                height: 14px;
                line-height: 14px;
                font-size: 10px;
                padding: 0 6px;
                border-radius: 7px;
                left: -10px;
                top: 20%;
            }
        }
        .home-package-info {
            min-height: 106px;
            position: relative;
            padding: 12px 0;
            .package-name {
                height: 22px;
                line-height: 22px;
                font-size: 14px;
                font-weight: 500;
                font-family: PingFang SC;
            }
            p {
                margin-top: 12px;
                font-family: Source Han Sans;
                font-size: 12px;
                font-variation-settings: "opsz" auto;
                font-feature-settings: "kern" on;
                color: rgba(0, 0, 0, 0.5);
                min-height: 18px;
                line-height: 18px;
            }
            .a_activeTime_name {
                display: inline-block;
                margin-right: 12px;
            }
            .state-tips { 
                color: #4361EE;
                font-family: Source Han Sans;
                font-size: 12px;
                position: absolute;
                right: 12px;
                top: 46px;
            }
            .state-tips-long {
                top: unset;
                bottom: 30px;
            }
        }
        .home-no-package {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 100%;
            height: 106px;
            font-size: 14px;
            color: #4361ee;
        }
    }
    .new-home-banner {
        margin-top: 12px;
        border-radius: 12px;
        overflow: hidden;
        height: 86px;
        .new-home-banner-item {
            position: relative;
            .link_to_text {
                position: absolute;
                bottom: 0;
                left: 0;
                background-color: rgba(0, 0, 0, 0.5);
                color: #fff;
                padding: 2px 6px;
                border-radius: 4px;
                font-size: 10px;
                pointer-events: none;
            }
        }
    }
    .new-home-nav-bar {
        margin-top: 12px;
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 12px 12px;
        position: relative;
        .new-home-nav-item {
            height: 94px;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            background-color: #fff;
            border-radius: 12px;
            img {
                width: 40px;
                height: 40px;
            }
            .name {
                margin-top: 8px;
                padding-right: 4px;
                padding-left: 4px;
                font-family: Source Han Sans;
                font-size: 14px;
                font-weight: 500;
                color: rgba(0, 0, 0, 0.85);
                font-variation-settings: "opsz" auto;
                font-feature-settings: "kern" on;
                text-align: center;
            }
            .coupon-icon-con {
                position: relative;
                span {
                    position: absolute;
                    top: 0;
                    right: -12px;
                    background-color: #FF4E4E;
                    color: #fff;
                    min-width: 20px;
                    height: 14px;
                    line-height: 14px;
                    border-radius: 7px;
                    font-size: 12px;
                    text-align: center;
                }
                .tip-dot {
                    position: absolute;
                    top: -2px;
                    right: -5px;
                    min-width: 20px;
                    height: 14px;
                }
            }
        }
        // .new-home-nav-item-center {
        //     position: absolute;
        //     width: 120px;
        //     height: 120px;
        //     border-radius: 60px;
        //     top: 50%;
        //     left: 50%;
        //     transform: translateX(-50%) translateY(-50%);
        //     border: 12px solid #f2f2f2;
        // }
    }
    .new-home-merits {
        margin-top: 12px;
        font-size: 14px;
        padding: 12px;
        background-color: #fff;
        border-radius: 12px;
        .new-home-merits-title {
            text-align: center;
            font-size: 14px;
            font-weight: 600;
        }
        .merits-item {
            margin-top: 5px;
            display: flex;
            align-items: center;
            border-radius: 8px;
            box-shadow: 0 3px 3px -3px rgba(0, 0, 0, 0.1);
            img {
                margin: 8px;
                width: 35px;
                height: 35px;
            }
        }
    }
    .new-home-power {
        color: #969799;
        font-size: 10px !important;
        text-align: center;
        font-family: Source Han Sans;
        margin-top: 20px;
        margin-bottom: 20px;
        width: 100%;
        -webkit-text-size-adjust: none
    }
    .new-home-footer {
      width: 100%;
      background-color: #fff;
      padding: 12px;
      position: fixed;
      bottom: 0;
      left: 0;
      .gobuy-btn {
        background-color: #4361ee;
        border-radius: 8px;
        width: 100%;
        height: 40px;
        transform: translateZ(0);
      }
    }
}
html[dir="rtl"] .new-home {
    .new-home-head {
        .home-avatar {
            margin-right: unset;
            margin-left: 12px;
        }
        .home-user-info {
            .user-account-con {
                .user-account-copy {
                    margin-left: unset;
                    margin-right: 8px;
                }
            }
            .user-imei-con {
                .user-imei-copy {
                    margin-left: unset;
                    margin-right: 8px;
                }
            }
        }
        .info-bg-img {
            right: unset;
            left: 0;
            transform: scaleX(-1);
        }
    }
    .new-home-banner {
        .new-home-banner-item {
            .link_to_text {
                left: unset;
                right: 0;
            }
        }
    }
    .new-home-package {
        .home-package-head {
            .my-flow-arrow {
                transform: scaleX(-1);
            }
            .order-num {
                left: unset;
                right: -10px;
            }
        }
        .home-package-info {
            .state-tips { 
                right: unset;
                left: 12px;
            }
        }
    }
}
</style>